export default __webpack_public_path__ + "static/media/ic_synapse.8b3e94cb.svg";